import { Booth } from '../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';

const BoothHeaderText = ({ booth }: { booth: Booth }) => {
  const event = useSelector((state) => state.admin.event ?? state.common.event);

  return (
    <h2 className="font-bold text-center lg:pl-4 booth-name">
      <span style={{ width: '-webkit-fill-available' }} className="italic truncate">
        {event?.settings?.useBoothNumber ? (booth.boothnumber ? `${booth.boothnumber}` : '') : ''}
      </span>
      <span> {booth.name}</span>
    </h2>
  );
};
export default BoothHeaderText;
